import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router";
import {clearStaleSession} from "./util/staleSession";

// BEFORE ANYTHING READS THE SESSION, and that is the whole reason it is here rather than in a
// component. A session that has been away too long is dropped on the way in; doing it inside the
// tree would mean the token had already been read, a request possibly already sent, and the user
// shown a page they were about to be logged out of.
clearStaleSession();

// Don't auto-open the login modal just because the user landed on / refreshed
// the app URL. The "ShowLoginDialog" flag persists in sessionStorage (e.g. it's
// set on logout), so without this a fresh landing re-pops the login screen.
// Clearing it on page load means login only opens via an explicit action
// (account icon / Home's Login button). In-session logout uses SPA navigation
// (no page reload), so this does not run then and logout still shows login.
if (sessionStorage.getItem("ShowLoginDialog") === "true") {
    sessionStorage.setItem("ShowLoginDialog", "false");
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
       <App />
    </BrowserRouter>
);
